import React from "react";

const PageNumbers = ({ total = 1, current = 1, baseSlug = "all-pages" }) => {
    const pageNumbers = [];

    // Always add the first page
    pageNumbers.push(1);

    if (total <= 5) {
        // If total pages are 5 or less, show all pages
        for (let i = 2; i <= total; i++) {
            pageNumbers.push(i);
        }
    } else {
        // Determine the middle pages based on current page
        if (current <= 3) {
            // Current page is among the first three
            for (let i = 2; i <= 4; i++) {
                pageNumbers.push(i);
            }

            pageNumbers.push("...");
        } else if (current >= total - 2) {
            // Current page is among the last three
            pageNumbers.push("...");

            for (let i = total - 3; i < total; i++) {
                pageNumbers.push(i);
            }
        } else {
            // Current page is somewhere in the middle
            pageNumbers.push("...");
            pageNumbers.push(current - 1);
            pageNumbers.push(current);
            pageNumbers.push(current + 1);
            pageNumbers.push("...");
        }
    }

    // Always add the last page if total is more than 5
    if (total > 5) {
        pageNumbers.push(total);
    }

    return (
        <div className="flex justify-center items-center gap-2">
            {pageNumbers.map((number, index) => {
                return number === "..." ? (
                    <div
                        key={index}
                        className="flex text-ec-disabled font-inter text-sm items-center justify-center w-9 h-9 rounded-md cursor-default"
                    >
                        {number}
                    </div>
                ) : (
                    <a
                        key={index}
                        href={`#/${baseSlug}/page/${number}`}
                        className={`w-9 h-9 flex items-center justify-center font-inter text-sm rounded-md
                            transition-colors duration-200 ${
                                number === Number(current)
                                    ? `text-white bg-ec-primary border border-ec-primary hover:bg-ec-hover hover:border-ec-hover`
                                    : "border border-ec-border hover:border-ec-primary hover:text-ec-primary text-ec-title"
                            }`}
                    >
                        {number}
                    </a>
                );
            })}
        </div>
    );
};

export default PageNumbers;